import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faClose } from '@fortawesome/free-solid-svg-icons/faClose';
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronDown  } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import {faCalendar} from "@fortawesome/free-solid-svg-icons/faCalendar";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faReply} from '@fortawesome/free-solid-svg-icons/faReply';
import { faArrowRotateRight} from '@fortawesome/free-solid-svg-icons/faArrowRotateRight';
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import {faCircleArrowUp} from "@fortawesome/free-solid-svg-icons/faCircleArrowUp";
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';
import {faUpLong} from "@fortawesome/free-solid-svg-icons/faUpLong";
import {faDownLong} from "@fortawesome/free-solid-svg-icons/faDownLong";

export const loadIcons = () => {
  library.add(
    faCalendar,
    faDownload,
    faFile,
    faBriefcase,
    faCircleXmark,
    faCircleInfo,
      faInfoCircle,
    faArrowLeft,
    faArrowRight,
    faCheckCircle,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faAsterisk,
    faBan,
    faBell,
    faBook,
    faCloud,
    faCogs,
    faCopy,
    faDatabase,
    faEye,
    faFlag,
    faHeart,
    faHome,
    faList,
    faLock,
    faTriangleExclamation,
    faPencil,
    faPencilAlt,
    faPlus,
    faRoad,
    faSave,
    faSignInAlt,
    faSignOutAlt,
    faSearch,
    faSort,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimesCircle,
    faTrash,
    faUser,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWrench,
    faClose,
    faGear,
    faPaperclip,
    faReply,
    faArrowRotateRight,
    faCircleArrowUp,
    faCheck,
    faFolder,
    faArrowUp,
    faPenToSquare,
    faUpLong,
    faDownLong
  );
};
